var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor google-play-reply-review" }, [
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Channel ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Play Channel ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.channelId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "channelId", $$v)
            },
            expression: "clone.channelId",
          },
        }),
        _vm._v(" "),
        _c("small", [_vm._v("Yanıt verilecek yorumun bulunduğu kanal ID'si")]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Review ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Play Review ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.reviewId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "reviewId", $$v)
            },
            expression: "clone.reviewId",
          },
        }),
        _vm._v(" "),
        _c("small", [_vm._v("Yanıt verilecek yorumun ID'si")]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Yanıt Metni")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Yanıt metni giriniz... (max 350 karakter)",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.text,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "text", $$v)
            },
            expression: "clone.text",
          },
        }),
        _vm._v(" "),
        _c(
          "small",
          {
            staticClass: "char-limit",
            class: { exceeded: _vm.textLength > 350 },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.textLength) +
                " / 350 karakter\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }